module.exports = __webpack_public_path__ + "static/img/yusbj2.af054cde.png";